import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Paper, withStyles, IconButton, Tooltip, Box } from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { Refresh } from '@material-ui/icons';

import { parseURL, BackButton, hasPermission, formatDate } from '../../sc-utilities';

import { snackActions } from '../../sc-utilities/SnackBar';
import * as pcProductActions from '../PCProduct/store/pcProductActions';
import * as watchProductActions from './store/watchProductActions';
import WatchProductMisc from './Details/WatchProductEditMisc';
import { downloadFile, updateURL } from '../../sc-utilities';
import { getMediaArrays } from '../../sc-media/utilities';
import config from '../../../config/config';
//import Presets from '../../sc-settings/Presets';

import * as batteryActions from '../../sc-productComponents/Battery/store/batteryActions';
import * as storageActions from '../../sc-productComponents/Storage/store/storageActions';
import ProductDontLoading from '../ProductDontLoading';

import ProductDetails from './WatchProductEditDetails';
import MediaGallery from '../../sc-media/MediaGallery';
import StorageList from '../../sc-productComponents/Storage';
import BatteryList from '../../sc-productComponents/Battery';
// import DiagnoseList from '../Diagnose/DiagnoseTab';
import Report from '../../sc-productComponents/Report';
import OEMPart from '../../sc-oemPart';
import {useChangeActiveCustomerModalHook} from "../hooks/useChangeActiveCustomerModalHook";
import StatisticModal from "../../sc-dashboard/Statistic/StatisticModal";
import {handleChangeCustomer} from "../../sc-dashboard/Statistic";
import * as action from "../../np-dashboard/CustomerBar/store/actions";
import WatchProductAuditRecord from "../../sc-productComponents/WatchProductAuditRecord";
import Diagnose from '../../sc-diagnose/Diagnose';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',

        margin: theme.spacing(),

        [theme.breakpoints.down('md')]: {
            width: `97.8%`
        },
        [theme.breakpoints.down('sm')]: {
            width: `97.8%`
        }
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ padding: 6, marginTop: '1%' }}>
            {props.children}
        </Typography>
    );
};
const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {((value === index || value < 6)) && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const ProductComponents = props => {
    const { classes, theme, onFetchWatchProduct, activeCustomer, onGenerateReportWatch, productEditable, fetchWatchOrders, permissions, onCleanBattery, translations, onCleanStorage, onCleanWatchState, watchProducts, onChangeActiveCustomer } = props;
    let searchParams = parseURL(window.location.search);
    const [tabValue, setTabValue] = useState(getTabValue());
    const [editable, setEditable] = useState({ editable: false, loading: false });
    const [signatures, setSignatures] = useState([]);
    const [mediaArrays, setMediaArrays] = useState({ videoArray: [], audioArray: [], imageArray: [] });
    const [deletedMedia, setDeletedMedia] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [redirectOptions, setRedirectOptions] = useChangeActiveCustomerModalHook(searchParams, activeCustomer);

    useEffect(() => {
        const fetchData = async () => {
            let isEditable = await productEditable({ ProductID: searchParams.productID, ActiveCustomerID: activeCustomer });
            setEditable({ editable: isEditable.productEditable, loading: true });
        }
        fetchData();
        return () => { };
    }, [activeCustomer, productEditable, searchParams.productID]);

    useEffect(() => {
        return () => {
            onCleanWatchState();
            onCleanBattery();
            onCleanStorage();
        };
    }, [onCleanWatchState, onCleanBattery, onCleanStorage]);

    useEffect(() => {

        if (watchProducts && watchProducts.loaded && watchProducts.loaded.Media && watchProducts.loaded.Media.length > 0) {
            const media = getMediaArrays(watchProducts.loaded.Media);
            setMediaArrays({ imageArray: media.tempImages, videoArray: media.tempVideos, audioArray: media.tempAudio });
        }

        if (watchProducts && watchProducts.loaded && watchProducts.loaded.Signatures && watchProducts.loaded.Signatures.length > 0) {
            let tempSignatures = [];
            const signaturePath = `${config.backend_domain}:${config.backend_port}/static-signature/`;

            watchProducts.loaded.Signatures.forEach((signature) => {
                if (!signature.Deleted) {
                    tempSignatures.push({
                        id: signature.SignatureID,
                        path: signaturePath + signature.ImageLocation,
                        type: 'signature',
                        createdAt: signature.CreatedAt ? formatDate(signature.CreatedAt) : ''
                    });
                }
            });
            setSignatures(tempSignatures);
        }
    }, [watchProducts]);

    const unlockEdit = () => {
        setEditable({ editable: true, loading: true });
        snackActions.snackBarComponent(`${translations['cant_edit_data_text'] || 'Now you can edit data, but it will be overwritten with latest request from QT'}.`, 'warning');
    }
    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };
    const getWatchLogData = async () => {
        let data = await props.onWatchDownload(searchParams.productID, { ActiveCustomerID: activeCustomer });
        if (data?.status !== 200) {
            return snackActions.snackBarComponent(data?.message ?? `${translations['not_find_session'] || 'Could not find session data'}!`, 'error');
        }
        if (data) {
            return downloadFile(data.blob, data.fileName);
        }
    };
    let disabled = (typeof watchProducts?.loaded === 'boolean' && !watchProducts?.loaded)

    const getProduct = async () => {
        await onFetchWatchProduct({ActiveCustomerID: activeCustomer, ProductID: searchParams?.productID});
    }

    return (
        <div>
            {!redirectOptions.open && <>
            <Paper className={classes.root}>
                {disabled ? null : BackButton(translations)}
                {tabValue < 6 && tabValue !== 2 ? <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} disabled={disabled} component="div" onClick={() => {
                            setRefresh(true);
                        }}>
                        <Refresh />
                    </IconButton>
                </Tooltip> : null}
                {
                    searchParams.type === 'WatchProduct' ?
                        <Tabs
                            value={tabValue}
                            onChange={handleChange}
                            indicatorColor="primary"
                            style={{ padding: 0 }}
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="on"
                        >
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["details"] || "Details"} value={0} /> : null}
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["misc"] || "MISC"} value={1}/> : null}
                            {hasPermission(permissions, 'product_audit_record_list') ? <Tab disabled={disabled} label={translations["audit_record"] || "Audit Record"} value={2}/> : null}
                            {hasPermission(permissions, 'oem_part_list') ? <Tab disabled={disabled} label={translations["oem_parts"] || "OEM Parts"} value={3}/> : null}
                            {hasPermission(permissions, 'erasure_report_list') ? <Tab disabled={disabled} label={translations["reports"] || "Reports"} value={4}/> : null}
                            {hasPermission(permissions, 'diagnose_case_round_results_list') && <Tab disabled={disabled} label={translations["diagnose"] || "Diagnose"} value={9} />}
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["media"] || "Media"} value={5}/> : null}
                            {/* {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["presets"] || "Presets"} value={6}/> : null} */}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["storages"] || "Storages"} value={7}/> : null}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["batteries"] || "Batteries"} value={8}/> : null}
                        </Tabs>
                        : null
                }
            </Paper>
            {hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={0} value={tabValue}>  <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && (tabValue===0 || tabValue === 5) ? <ProductDetails onFetchWatchProduct={onFetchWatchProduct} deletedMedia={deletedMedia} setDeletedMedia={setDeletedMedia} translations={translations} tabValue={tabValue} sendMessage={props.sendMessage} onUnpairBulkExternalWatch={props.onUnpairBulkExternalWatch} onUnpairExternalWatch={props.onUnpairExternalWatch} permissions={permissions} editable={editable?.editable} unlockEdit={unlockEdit} productEditable={props.productEditable} moveToAnotherPalette={props.moveWatchToAnotherPalette} fetchOrders={fetchWatchOrders} onLoadedCleanup={props.watchProductEditInit} onDeleteProduct={props.onDeleteWatchProduct} getLogData={getWatchLogData} onEditProduct={props.onEditWatchProduct} fetchTypicalProblems={props.onFetchWatchTypicalProblems} fetchGrades={props.onFetchWatchGrades} fetchGradingCategories={props.onFetchWatchGradingCategories} productID={searchParams.productID} type={searchParams.type} product={props.watchProducts} onFetchProduct={props.onFetchWatchProduct} fetchCollies={props.fetchCollies} setRefresh={setRefresh} refresh={refresh} /> : <ProductDontLoading />}</TabContainer> </TabPanel > : null}
            { hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={1} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue===1 ? <WatchProductMisc onFetchWatchProduct={onFetchWatchProduct} refresh={refresh} translations={translations} activeCustomer={activeCustomer} permissions={permissions} editable={editable.editable} unlockEdit={unlockEdit} productID={searchParams.productID} product={props.watchProducts.loaded} onEditProduct={props.onEditWatchProduct} /> : <ProductDontLoading />} </TabContainer>  </TabPanel > : null}
            { hasPermission(permissions, 'product_audit_record_list') && editable.loading ? <TabPanel index={2} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue===2 ? <WatchProductAuditRecord refresh={refresh} translations={translations} activeCustomer={activeCustomer} permissions={permissions} editable={editable.editable} productID={searchParams.productID} product={props.watchProducts.loaded}  /> : <ProductDontLoading />} </TabContainer>  </TabPanel > : null}
            { hasPermission(permissions, 'oem_part_list') && editable.loading ? <TabPanel index={3} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue===3 ?
                <OEMPart /> : <ProductDontLoading />} </TabContainer>  </TabPanel > : null}

            { hasPermission(permissions, 'erasure_report_list') && editable.loading ?
                <TabPanel index={4} value={tabValue}> <TabContainer dir={theme.direction}>{!disabled && tabValue === 4 ? <Report onGenerate={onGenerateReportWatch} tabValue={tabValue} productID={searchParams.productID} isSingleTab={true}/> : <ProductDontLoading />}</TabContainer>  </TabPanel > : null}

            { hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={5} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue===5 ? <MediaGallery productID={searchParams.productID} refresh={refresh} onRefresh={() => setDeletedMedia(true)} entity={translations['product'] || 'Product'} translations={translations} images={mediaArrays.imageArray} videos={mediaArrays.videoArray} audio={mediaArrays.audioArray} signatures={signatures} permissions={permissions} /> : <ProductDontLoading />} </TabContainer>  </TabPanel > : null}
            {/* {hasPermission(permissions, 'product_load') && editable.loading ? 
            <TabPanel index={6} value={tabValue}>
                <TabContainer dir={theme.direction}>{!disabled && tabValue === 6 ? 
                    <Presets loadPresets={getProduct} updatePresets={onUpdatePresets} loadedPreset={watchProducts.loaded} idParams={{ProductID: searchParams?.productID}}  /> : 
                    <ProductDontLoading />} 
                </TabContainer>    
            </TabPanel> : <></>} */}

            { hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={7} value={tabValue}> <TabContainer dir={theme.direction}>{!disabled && tabValue === 7 ? <StorageList editable={editable.editable} translations={translations} tabValue={tabValue} productID={searchParams.productID} /> : <ProductDontLoading />}</TabContainer>  </TabPanel > : null}
            { hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={8} value={tabValue}> <TabContainer dir={theme.direction}>{!disabled && tabValue === 8 ? <BatteryList editable={editable.editable} translations={translations} tabValue={tabValue} productID={searchParams.productID} /> : <ProductDontLoading />}</TabContainer>  </TabPanel > : null}
            { hasPermission(permissions, 'diagnose_case_round_results_list') && editable.loading ? <TabPanel index={9} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue === 9 ? <Diagnose onFetchWatchProduct={onFetchWatchProduct} translations={translations} tabValue={tabValue} permissions={permissions} productID={searchParams.productID} ClientType={"watch"} /> : <ProductDontLoading />}</TabContainer> </TabPanel> : <></>}
            </>}
            {redirectOptions.open ?
                <StatisticModal open={redirectOptions.open}
                                product={redirectOptions.product}
                                handleChangeCustomer={() => handleChangeCustomer(onChangeActiveCustomer, redirectOptions)}
                                handleCloseSafe={() => setRedirectOptions({
                                    ...redirectOptions,
                                    open: !redirectOptions.open
                                })}
                                translations={translations} activeCustomer={activeCustomer} />
                : null}
        </div >
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        pcProducts: state.product.pcProducts,
        watchProducts: state.product.watchProducts,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        storage: state.product.storageProducts,
        permissions: state?.core?.login?.permissions || []
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onCleanBattery: () => dispatch(batteryActions.cleanState()),
        onCleanStorage: () => dispatch(storageActions.cleanState()),
        productEditable: data => dispatch(pcProductActions.productEditable(data)),
        onGenerateReportWatch: (watchProduct, translations) => dispatch(watchProductActions.generateReport(watchProduct, translations)),

        onUnpairExternalWatch: externalID => dispatch(watchProductActions.unpairExternal(externalID)),
        onUnpairBulkExternalWatch: externalIDs => dispatch(watchProductActions.unpairBulkExternalWatch(externalIDs)),
        onFetchWatchProduct: product => dispatch(watchProductActions.loadWatchProduct(product)),
        onEditWatchProduct: product => dispatch(watchProductActions.editWatchProduct(product)),
        onFetchWatchGrades: product => dispatch(watchProductActions.fetchGrades(product)),
        onFetchWatchGradingCategories: product => dispatch(watchProductActions.fetchGradingCategories(product)),
        onFetchWatchTypicalProblems: (id) => dispatch(watchProductActions.fetchTypicalProblems(id)),
        onBulkDeleteWatchProducts: (id) => dispatch(watchProductActions.bulkDeleteWatchProducts(id)),
        onDeleteWatchProduct: (product) => dispatch(watchProductActions.deleteWatchProduct(product)),
        onWatchDownload: (productID, customerID) => dispatch(watchProductActions.downloadRawData(productID, customerID)),
        watchProductEditInit: (id) => dispatch(watchProductActions.loadWatchProductInit(id)),
        fetchWatchOrders: (id) => dispatch(watchProductActions.fetchOrders(id)),
        moveWatchToAnotherPalette: data => dispatch(watchProductActions.moveToAnotherPalette(data)),
        onCleanWatchState: () => dispatch(watchProductActions.cleanState()),
        onChangeActiveCustomer: (customerID, path) => dispatch(action.changeActiveCustomer(customerID, path)),

        onUpdatePresets: data => dispatch(pcProductActions.updatePresets(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(ProductComponents));